<div class="status-pie-chart">
  <div class="status-pie-chart__donut" data-testid="status-pie-donut">
    <svg
      class="status-pie-chart__svg"
      viewBox="0 0 32 32"
      role="img"
      [attr.aria-label]="'Distribuição de adesões por status'"
    >
      @for (slice of pieSlices(); track $index) {
        <circle
          class="status-pie-chart__slice"
          cx="16"
          cy="16"
          r="12"
          fill="none"
          stroke-width="8"
          [attr.pathLength]="pathLength"
          [attr.stroke]="slice.color"
          [attr.stroke-dasharray]="slice.dashArray"
          [attr.stroke-dashoffset]="slice.dashOffset"
        ></circle>
      }
    </svg>
    <span class="status-pie-chart__total" data-testid="status-pie-total">{{ total() }}</span>
  </div>

  <ul class="status-pie-chart__legend">
    @for (segment of segments(); track segment.label) {
      <li class="status-pie-chart__legend-item">
        <span class="status-pie-chart__dot" [style.background-color]="segment.color"></span>
        <span class="status-pie-chart__legend-label">{{ segment.label }}</span>
        <span class="status-pie-chart__legend-value" data-testid="status-pie-legend-value">
          {{ segment.value }} ({{ percentOf(segment.value) }})
        </span>
      </li>
    }
  </ul>
</div>
